import { createSlice } from "@reduxjs/toolkit";
import type { NPV, NpvHelpers } from "@/pages/household/NPV/npv-utils";
import type { NPVSettings, NPVRow, Clients } from "@/types/types";
import { UPHeader } from "../uq/uq-slice";

export type NPVHeader = "NPVSolution" | "InvestmentWithdrawals" | "Investment" | "NPV" | UPHeader;

export type Titles = {
  [T in Exclude<NPVHeader, "">]: string;
};

type InitialState = {
  isModified: boolean;
  settings: NPVSettings;
  headerTitles: Titles;
  localHousehold: Clients | null;
  gridSet: NPVRow[] | [];
  npv: NPV[] | [];
  npvHelper: NpvHelpers[] | [];
  maxClientsAge: number;
  shouldStopAtAge: number;
};

const initialState: InitialState = {
  settings: {
    npvAge: 5,
    yearsToRetire: 0,
    irr: 0.05,
    person1: {
      beginAt: 0,
      amount: 0,
      showAge: true,
      showSS: true,
    },
    person2: {
      beginAt: 0,
      amount: 0,
      showAge: true,
      showSS: true,
    },
  },
  localHousehold: null,
  gridSet: [],
  isModified: false,
  header: "",
  headerTitles: {
    Income1: "",
    Income2: "",
    Investment: "",
    NPV: "",
    Pension: "",
    SocialSecurity: "",
    Spending: "",
    Spending2: "",
    Spending3: "",
    YearEnd: "",
  },
  npv: [],
  npvHelper: [],
  maxClientsAge: 0,
  shouldStopAtAge: 0,
};

const npvSlice = createSlice({
  name: "npv",
  initialState: initialState,
  reducers: {
    setTitles(state, action) {
      state.headerTitles = action.payload;
    },
    setSettings(state, action) {
      if (typeof action.payload === "string") {
        state.settings = JSON.parse(action.payload);
        return;
      }
      state.settings = action.payload;
    },
    setGrid(state, action) {
      state.gridSet = action.payload;
    },
    setIsModified(state, action) {
      state.isModified = action.payload;
    },
    setLocalHousehold(state, action) {
      state.localHousehold = action.payload;
    },
    setNpvHelpers(state, action) {
      state.npvHelper = action.payload;
    },
    setNpv(state, action) {
      state.npv = action.payload;
    },
    setMaxClientsAge(state, action) {
      state.maxClientsAge = action.payload;
    },
    setShouldStopAtAge(state, action) {
      state.shouldStopAtAge = action.payload;
    },
  },
});
export const npvActions = npvSlice.actions;
export default npvSlice;
